/* eslint-disable */
/*
 * @Descripttion:
 * @version:
 * @Author: susj
 * @Date: 2020-09-25 14:11:10
 * @LastEditors: yinj
 * @LastEditTime: 2021-02-20 16:30:27
 */

import { findObjItem, abbr2sty, sty2abbr } from '@/utils/element';
import insertData from '@/utils/insertData';

export const asyncData2workData = (asyncData) => {
  let workData = JSON.parse(JSON.stringify(asyncData).replace(/slideResults/g, 'pages').replace(/slideInfoResults/g, 'elements').replace(/elementType/g, 'name'))
  if (!workData.pages) {
    workData.pages = [{ elements: [] }]
  }
  workData.pages.forEach((page) => {
    page.uuid = page.id;
    const bgObj = {
      name: 'ppt-background',
      uuid: page.id,
      id: page.id,
      slideId: page.id,
      pptId: workData.id,
      bgImage: page.bgImage || '',
      bgColor: page.bgColor || '',
    };
    page.elements.unshift(bgObj);
    page.elements.forEach((ele) => {
      ele.quId = ele.uuId;
      ele.uuid = ele.id;
      ele.groupId = ele.groupId;
      ele.pluginProps = {};
      ele.commonStyle = {};
      ele.name === 'image' && (ele.name = 'ppt-picture');
      ele.name === 'text' && (ele.name = 'ppt-text');
      ele.name === 'table' && (ele.name = 'ppt-table');
      // 表格，需要把content内容取出，转换
      if (ele.name === 'ppt-table') {
        ele.pluginProps.table = JSON.parse(ele.content);
        ele.pluginProps.areaContentType = ele.areaContentType; // 报价表格类型
        const { row_height, column_width } = ele.pluginProps.table;
        ele.pluginProps.width = column_width.reduce((pre, cur) => Number(pre) + Number(cur));
        ele.pluginProps.height = row_height.reduce((pre, cur) => Number(pre) + Number(cur));
      }
      if (ele.name === 'area') {
        const typeToName = {
          text: 'ppt-text-template',
          quote: 'ppt-table-template',
          picture: 'ppt-picture-template',
          roomName: 'ppt-text-template',
          panorama:'ppt-picture-template',
          sentence:'ppt-text-template'
        }
        ele.name = typeToName[ele.type] ? typeToName[ele.type] : typeToName.picture;
        ele.pluginProps.contentType = ele.contentType
        const areaTypeName = findObjItem(insertData.insertData, 'val', ele.type)?.name
        if(ele.type==='roomName') {
          ele.pluginProps.contentName = areaTypeName
        } else if(ele.type==='sentence') {
          let extraIds = ele.extraIdTwo.split('|');
          ele.pluginProps.extraIdTwo  = extraIds[0];
          ele.pluginProps.extraIdThree = extraIds[1]?extraIds[1]:''
          ele.pluginProps.extraId  = ele.extraId
          ele.pluginProps.sentenceList  = ele.sentenceList || []
          ele.pluginProps.contentName = ele.sentenceList? ele.sentenceList[0].content: ''
        } else {
          ele.pluginProps.contentName = ele.contentType ? areaTypeName + '-' + findObjItem(insertData.insertDataItem[ele.type], 'val', ele.contentType).name : areaTypeName
        }
        ele.pluginProps.areaType = ele.type
        if(ele.name==='ppt-text-template') {
          ele.pluginProps.textStyle = ele.textStyle? abbr2sty(ele.textStyle): ''
        }
      }
      ele.uuid != undefined && (ele.pluginProps.uuid = ele.id);
      if (ele.content != undefined) {
        ele.content = abbr2sty(ele.content)
        ele.pluginProps.content = ele.content
        ele.pluginProps.contentIsFocus = false

      }
      ele.bgColor != undefined && (ele.pluginProps.bgColor = ele.bgColor);
      ele.bgImage != undefined && (ele.pluginProps.bgImage = ele.bgImage);
      ele.imagePath != undefined && (ele.pluginProps.imagePath = ele.imagePath);
      ele.backgroundColor != undefined && (ele.pluginProps.backgroundColor = ele.backgroundColor);
      ele.top != undefined && (ele.commonStyle.top = ele.top);
      ele.left != undefined && (ele.commonStyle.left = ele.left);
      ele.width != undefined && (ele.commonStyle.width = ele.width);
      ele.height != undefined && (ele.commonStyle.height = ele.height);
      ele.textAlign != undefined && (ele.commonStyle.textAlign = ele.textAlign);
      ele.color != undefined && (ele.commonStyle.color = ele.color);
      ele.backgroundColor != undefined && (ele.commonStyle.backgroundColor = ele.backgroundColor);
      ele.fontSize != undefined && (ele.commonStyle.fontSize = ele.fontSize);
      ele.rotation != undefined && (ele.commonStyle.rotation = ele.rotation);
      ele.flipHorizontal != undefined && (ele.commonStyle.flipHorizontal = ele.flipHorizontal);
      ele.flipVertical != undefined && (ele.commonStyle.flipVertical = ele.flipVertical);
    });
  });
  return workData;
}
export const workData2asyncData = (workData) => {
  let asyncData = JSON.parse(JSON.stringify(workData).replace(/pages/g, 'slideResults').replace(/elements/g, 'slideInfoResults').replace(/uuid/g, 'id').replace(/name/g, 'elementType'))
  asyncData.slideResults.forEach((page) => {
    page.slideInfoResults.forEach(ele => {
      if (ele.elementType == 'ppt-background') {
        page.bgImage = ele.bgImage || ''
        page.bgColor = ele.bgColor || ''
      }
      ele.elementType === 'ppt-picture' && (ele.elementType = 'image');
      if (ele.elementType === 'ppt-text') {
        ele.pluginProps.content = sty2abbr(ele.pluginProps.content)
      }
      ele.elementType === 'ppt-text' && (ele.elementType = 'text');

      ele.elementType === 'ppt-text-template' && (ele.elementType = 'area');
      ele.elementType === 'ppt-picture-template' && (ele.elementType = 'area');
      if (ele.elementType === 'area') {
        ele.type = ele.pluginProps.areaType
      }
      Object.assign(ele, ele.commonStyle, ele.pluginProps)
      delete ele.commonStyle
      delete ele.pluginProps
    })
    page.slideInfoResults.splice(0, 1)
  })
  return asyncData;
}